import { render, staticRenderFns } from "./EventsChart.vue?vue&type=template&id=1d7b820d&"
import script from "./EventsChart.vue?vue&type=script&lang=js&"
export * from "./EventsChart.vue?vue&type=script&lang=js&"
import style0 from "./EventsChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventsChart.vue"
export default component.exports